import { Layout } from './Layout';
import { PublicLayout } from './PublicLayout';
import { LoadingSpinner } from './ui/LoadingSpinner';
import { useAuth } from '@/hooks/useAuth';

/**
 * Условный layout для read-only маршрутов (списки/детали организаций, площадок,
 * очередей): рендерит полноценный {@link Layout} (sidebar, user-menu, WS, уведомления)
 * для аутентифицированного пользователя либо {@link PublicLayout} (компактный хедер
 * с «Войти/Регистрация») для анонима.
 * <p>
 * Оба компонента являются layout-route'ами — содержат собственный &lt;Outlet/&gt;,
 * поэтому дочерние маршруты (объявленные внутри этого Route в App.tsx) рендерятся
 * внутри выбранного layout'а.
 * <p>
 * В отличие от {@link ProtectedRoute}, НЕ редиректит анонима на /auth/login — даёт
 * просматривать публичные сущности. Сами страницы скрывают действия (create/edit/join)
 * по флагу isAuthenticated и при клике редиректят на логин.
 * <p>
 * isLoading (инициализация auth из localStorage) показываем спиннером, чтобы до
 * разрешения гидратации не мелькал публичный layout для залогиненного пользователя.
 */
export function PublicOrProtectedLayout() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return isAuthenticated ? <Layout /> : <PublicLayout />;
}
